import { Component, ChangeDetectionStrategy, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PageTabsComponent, PageTab } from 'src/app/core/components/page-tabs/page-tabs.component';
import { AuditLogComponent } from './components/audit-log/audit-log.component';

@Component({
  selector: 'app-customer-settings',
  standalone: true,
  imports: [CommonModule, PageTabsComponent, AuditLogComponent],
  templateUrl: './customer-settings.component.html',
  styleUrl: './customer-settings.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CustomerSettingsPage {
  public tabs: PageTab[] = [
    { id: 'audit-log', label: 'Audit Log' },
    // MF Note: Future tabs are added to this array.
    // Planning items like API Keys, White Label, Multi-Tenant Settings
  ];

  public activeTab = signal<string>('audit-log');

  public onTabChange(tabId: string): void {
    this.activeTab.set(tabId);
  }
}
